import { render, staticRenderFns } from "./pricelist-create.vue?vue&type=template&id=533ec9c9&"
import script from "./pricelist-create.vue?vue&type=script&lang=js&"
export * from "./pricelist-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports